export default __webpack_public_path__ + "static/media/CSIO_2021_Annual_Report_CL_Working_Groups.18328508.pdf";